export default __webpack_public_path__ + "static/media/thumb_basic.bdab8470.webp";